import { Box } from '@mui/material';

interface TestEnvironmentBadgeProps {
  visible: boolean;
}

export const TestEnvironmentBadge = ({ visible }: TestEnvironmentBadgeProps) => {
  if (!visible) return null;

  return (
    <Box
      component="span"
      role="status"
      aria-label="Test environment - may contain production data"
      sx={{
        position: 'fixed',
        top: 8,
        left: '50%',
        zIndex: (theme) => theme.zIndex.tooltip + 1,
        transform: 'translateX(-50%)',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        boxSizing: 'border-box',
        minHeight: 24,
        maxWidth: 'calc(100vw - 16px)',
        px: 1,
        py: 0.5,
        borderRadius: 1,
        bgcolor: '#ff9800',
        color: '#000000',
        boxShadow: 2,
        pointerEvents: 'none',
        fontSize: '0.6875rem',
        fontWeight: 800,
        lineHeight: 1.2,
        letterSpacing: 0,
        overflowWrap: 'anywhere',
        textAlign: 'center',
      }}
    >
      TEST - MAY CONTAIN PRODUCTION DATA
    </Box>
  );
};
